enum Region {
  AU = 'AU',
  GB = 'GB'
}

export default Region;
